import "./App.css";
import { Tic } from "./Tic";

function App() {
  return (
    <main>
      <Tic />
    </main>
  );
}

export default App;
